//auth
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REGISTRATION = 'AUTH_REGISTRATION';
export const AUTH_RESTORE_PASSWORD = 'AUTH_RESTORE_PASSWORD';
export const AUTH_SET_NEW_PASSWORD = 'AUTH_SET_NEW_PASSWORD';
export const AUTH_ACTIVATION_EMAIL = 'AUTH_ACTIVATION_EMAIL';
export const AUTH_WITH_SOCIAL = 'AUTH_WITH_SOCIAL';
export const AUTH_SET_TOKENS = 'AUTH_SET_TOKENS';
export const AUTH_REMOVE_TOKENS = 'AUTH_REMOVE_TOKENS';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';

//setting
export const GET_TRANSLATIONS = 'GET_TRANSLATIONS';
export const GET_CONFIG = 'GET_CONFIG';
export const GET_SETTING = 'GET_SETTING';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_SERVER_TIME = 'GET_SERVER_TIME';

//profile
export const GET_USER_DATA = 'GET_USER_DATA';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const PASSWORD_UPDATE = 'PASSWORD_UPDATE';


// header
export const HEADER_FETCH_NOTIFICATION_COURSES = 'HEADER_FETCH_NOTIFICATION_COURSES';
export const HEADER_REMOVE_NOTIFICATION = 'HEADER_REMOVE_NOTIFICATION';
export const HEADER_READ_NOTIFICATION = 'HEADER_READ_NOTIFICATION';
export const HEADER_REMOVE_ALL_NOTIFICATIONS = 'HEADER_REMOVE_ALL_NOTIFICATIONS';
export const HEADER_READ_ALL_NOTIFICATIONS = 'HEADER_READ_ALL_NOTIFICATIONS';

// courses meetups
export const FETCH_MEETUPS = 'FETCH_MEETUPS';
export const FETCH_MEETUPS_ITEM = 'FETCH_MEETUPS_ITEM';

// news
export const FETCH_NEWS = 'FETCH_NEWS';
export const FETCH_NEWS_ITEM = 'FETCH_NEWS_ITEM';

// main
export const GET_LIST = 'GET_LIST';
export const GET_LIST_ITEM = 'GET_LIST_ITEM';
export const GET_CATEGORIES = 'GET_CATEGORIES';

//action

export const UPDATE_PROGRESS = 'UPDATE_PROGRESS';
export const START_TEST = 'START_TEST';
export const COMPLETE_QUESTION = 'COMPLETE_QUESTION';
export const COMPLETE_TEST = 'COMPLETE_TEST';
export const GET_REPORT = 'GET_REPORT';
export const ATTACH_TESTS = 'ATTACH_TESTS';
export const GET_LIST_COUNT = 'GET_LIST_COUNT';
export const GET_TIMEZONES = 'GET_TIMEZONES';
export const GET_COUNTRY = 'GET_COUNTRY';
